import { render, staticRenderFns } from "./CreateMake.vue?vue&type=template&id=77188b7a&"
import script from "./CreateMake.vue?vue&type=script&lang=js&"
export * from "./CreateMake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports